module.exports = "//static.hsappstatic.net/ecosystem-marketplace-solutions-base/static-1.5735/img/partner-award-badge.svg"